import { render } from "./SaveEmployee.vue?vue&type=template&id=1f510646&scoped=true"
import script from "./SaveEmployee.vue?vue&type=script&lang=js"
export * from "./SaveEmployee.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=1f510646&lang=scss&scoped=true"
import "./SaveEmployee.vue?vue&type=style&index=1&id=1f510646&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f510646"]])

export default __exports__